import React from "react";

const RetailAgentAgreement = () => {
  return (
    <section
      id="retail_agent_agreement"
      className="ico_about_section section_space section_decoration bg-white"
    >
      <div className="container">
        <div className="row justify-content-lg-between">
          <div className="col-lg-12">
            <h4 className="title_text text-dark mb-3">
              Becoming a Retail Business Advertising Agent Agreement
            </h4>
            <p className="text-dark fw-semibold opacity-75">
              <strong>TOPCOIN UK LTD</strong>
              <br />
              <strong>
                RETAIL M AGENT &amp; SENIOR RETAIL AGENT AGREEMENT
              </strong>
            </p>

            <h5 className="title_text text-dark mt-4">
              Agent Participation Notice
            </h5>
            <p className="text-dark opacity-75 mb-2">
              This Agreement sets out the terms for members who wish to
              participate as a <strong>Retail M Agent</strong> or{" "}
              <strong>Senior Retail Agent</strong> within the TopCoin UK
              platform.
            </p>
            <p className="text-dark opacity-75 mb-2">
              The Retail Agent Programme is designed to help expand the TopCoin
              UK business network by allowing approved Retail Agents to
              introduce eligible shops, retailers and other businesses to the
              platform.
            </p>
            <p className="text-dark opacity-75 mb-4">
              Participation as a Retail Agent is separate from ordinary customer
              membership. Members wishing to become Retail Agents must apply
              through the TopCoin UK platform, receive approval and accept the
              applicable terms.
            </p>

            <h5 className="title_text text-dark">1. Platform Purpose</h5>
            <p className="text-dark opacity-75 mb-2">
              TopCoin UK Ltd operates a loyalty and promotional platform
              connecting customers with participating businesses.
            </p>
            <p className="text-dark opacity-75 mb-2">
              The Retail Agent Programme supports the expansion of the TopCoin
              UK business network by allowing approved Retail Agents to
              introduce businesses that may wish to participate on the platform.
            </p>
            <p className="text-dark opacity-75 mb-4">
              Participating businesses remain responsible for their own
              products, services and customer relationships.
            </p>

            <h5 className="title_text text-dark">2. Retail M Agent Role</h5>
            <p className="text-dark opacity-75 mb-2">
              An eligible TopCoin UK member may apply to become a{" "}
              <strong>Retail M Agent</strong>.
            </p>
            <p className="text-dark opacity-75 mb-2">
              Retail M Agents help expand the platform by:
            </p>
            <ul className="text-dark opacity-75 mb-2">
              <li>
                introducing eligible shops, retailers and businesses to TopCoin
                UK;
              </li>
              <li>
                explaining the purpose and general operation of the TopCoin UK
                platform;
              </li>
              <li>
                helping prospective businesses understand the onboarding
                process; and
              </li>
              <li>
                supporting responsible growth of the participating business
                network.
              </li>
            </ul>
            <p className="text-dark opacity-75 mb-4">
              Retail Agents may only make representations about TopCoin UK that
              are accurate and authorised by TopCoin UK Ltd.
            </p>

            <h5 className="title_text text-dark">3. Introducing Businesses</h5>
            <p className="text-dark opacity-75 mb-2">
              Approved Retail M Agents may introduce prospective businesses to
              the TopCoin UK platform using authorised referral links, systems
              or other approved methods.
            </p>
            <p className="text-dark opacity-75 mb-2">
              Where a business is introduced through the appropriate Retail
              Agent process, TopCoin UK may record the Retail Agent as the
              introducing Agent.
            </p>
            <p className="text-dark opacity-75 mb-2">
              An introduction does not guarantee that a business will be
              accepted onto the platform.
            </p>
            <p className="text-dark opacity-75 mb-4">
              TopCoin UK Ltd retains responsibility for determining whether a
              prospective business satisfies the applicable participation and
              onboarding requirements.
            </p>

            <h5 className="title_text text-dark">
              4. Participating Businesses
            </h5>
            <p className="text-dark opacity-75 mb-2">
              Businesses introduced by Retail Agents participate directly with
              the <strong>TopCoin UK platform</strong> under the applicable
              business terms and programme rules.
            </p>
            <p className="text-dark opacity-75 mb-2">
              The Retail Agent acts as an introducer and does not own, control
              or acquire exclusive rights over an introduced business.
            </p>
            <p className="text-dark opacity-75 mb-4">
              The business remains responsible for its own commercial
              operations, products, services, employees, customers and legal
              obligations.
            </p>

            <h5 className="title_text text-dark">
              5. Retail Agents Do Not Represent Participating Businesses
            </h5>
            <p className="text-dark opacity-75 mb-2">
              Retail Agents must not present themselves as owners, employees,
              partners or authorised representatives of businesses they
              introduce unless a separate relationship genuinely exists.
            </p>
            <p className="text-dark opacity-75 mb-4">
              Retail Agents must not enter into agreements, make contractual
              commitments or make promises on behalf of a participating
              business.
            </p>

            <h5 className="title_text text-dark">
              6. Eligibility for Senior Retail Agent Status
            </h5>
            <p className="text-dark opacity-75 mb-2">
              A Retail M Agent may become eligible to apply for or be considered
              for <strong>Senior Retail Agent</strong> status after introducing
              a minimum of <strong>50 participating businesses</strong> to the
              TopCoin UK platform.
            </p>
            <p className="text-dark opacity-75 mb-2">
              Reaching 50 participating businesses does not automatically
              guarantee Senior Retail Agent status.
            </p>
            <p className="text-dark opacity-75 mb-4">
              Eligibility remains subject to verification, programme
              requirements and approval by TopCoin UK Ltd.
            </p>

            <h5 className="title_text text-dark">
              7. Senior Retail Agent Role
            </h5>
            <p className="text-dark opacity-75 mb-2">
              Senior Retail Agents may support the development and responsible
              expansion of the TopCoin UK business network.
            </p>
            <p className="text-dark opacity-75 mb-2">Their role may include:</p>
            <ul className="text-dark opacity-75 mb-2">
              <li>supporting and guiding Retail M Agents;</li>
              <li>introducing eligible businesses to TopCoin UK;</li>
              <li>promoting awareness of the TopCoin UK platform;</li>
              <li>
                helping expand the network of participating businesses; and
              </li>
              <li>
                supporting the standards and objectives of the Retail Agent
                Programme.
              </li>
            </ul>
            <p className="text-dark opacity-75 mb-4">
              Senior Retail Agents remain subject to TopCoin UK policies and
              applicable Agent terms.
            </p>

            <h5 className="title_text text-dark">
              8. Advertising Agent Participation
            </h5>
            <p className="text-dark opacity-75 mb-2">
              Retail Agents who also wish to introduce customers may separately
              apply to participate in the{" "}
              <strong>Customer Advertising Agent Programme</strong>.
            </p>
            <p className="text-dark opacity-75 mb-2">
              Eligible Retail Agents may apply to become{" "}
              <strong>Customer Advertising M Agent</strong> or{" "}
              <strong>Senior Advertising Agent</strong>.
            </p>
            <p className="text-dark opacity-75 mb-2">
              Customer Advertising Agent participation is separate and may be
              governed by the applicable Customer Advertising Agent Agreement.
            </p>
            <p className="text-dark opacity-75 mb-4">
              Approval as a Retail Agent does not automatically provide
              Advertising Agent status.
            </p>

            <h5 className="title_text text-dark">9. Agent Conduct</h5>
            <p className="text-dark opacity-75 mb-2">
              Retail Agents must promote TopCoin UK accurately, responsibly and
              professionally.
            </p>
            <p className="text-dark opacity-75 mb-2">
              Retail Agents must not make false or misleading statements about
              TopCoin UK; make unauthorised promises to prospective businesses;
              misrepresent the TopCoin UK platform or loyalty programme;
              guarantee that a business will be accepted onto the platform;
              present themselves as employees of TopCoin UK Ltd unless
              separately employed; use aggressive, deceptive or inappropriate
              promotional practices; misuse business, customer or platform
              information; or use TopCoin UK branding without appropriate
              authorisation.
            </p>
            <p className="text-dark opacity-75 mb-4">
              Serious or repeated breaches may result in restriction, suspension
              or termination of Retail Agent participation.
            </p>

            <h5 className="title_text text-dark">
              10. Independent Participation
            </h5>
            <p className="text-dark opacity-75 mb-2">
              Unless otherwise agreed in writing, Retail Agents participate
              independently.
            </p>
            <p className="text-dark opacity-75 mb-2">
              Nothing in this Agreement creates an employment relationship,
              partnership, joint venture, franchise or authority for a Retail
              Agent to legally bind TopCoin UK Ltd.
            </p>
            <p className="text-dark opacity-75 mb-4">
              Retail Agents must not enter into agreements or make commitments
              on behalf of TopCoin UK Ltd without written authority.
            </p>

            <h5 className="title_text text-dark">
              11. Business and Customer Data
            </h5>
            <p className="text-dark opacity-75 mb-2">
              Retail Agents must handle personal and business information
              responsibly and in accordance with applicable data-protection
              requirements and TopCoin UK policies.
            </p>
            <p className="text-dark opacity-75 mb-2">
              Information obtained through the Retail Agent Programme must not
              be collected, retained, disclosed or used for unauthorised
              purposes.
            </p>
            <p className="text-dark opacity-75 mb-4">
              Information held within the TopCoin UK platform remains subject to
              the applicable privacy and data-protection policies.
            </p>

            <h5 className="title_text text-dark">
              12. Brand and Intellectual Property
            </h5>
            <p className="text-dark opacity-75 mb-2">
              The TopCoin UK name, logos, branding, software, platform systems,
              technology, content and other intellectual property remain the
              property of TopCoin UK Ltd or their respective rights holders.
            </p>
            <p className="text-dark opacity-75 mb-2">
              Retail Agents may use authorised TopCoin UK materials only for
              approved Retail Agent activities and in accordance with applicable
              brand guidelines.
            </p>
            <p className="text-dark opacity-75 mb-4">
              Agents may not copy, modify, reproduce or misuse protected TopCoin
              UK materials without permission.
            </p>

            <h5 className="title_text text-dark">
              13. Confidential Information
            </h5>
            <p className="text-dark opacity-75 mb-2">
              Non-public information relating to TopCoin UK's systems,
              technology, business operations, participating businesses, Agent
              Programme or internal processes must be treated as confidential
              where applicable.
            </p>
            <p className="text-dark opacity-75 mb-4">
              Retail Agents must not disclose or use confidential information
              for unauthorised purposes.
            </p>

            <h5 className="title_text text-dark">
              14. International Participation
            </h5>
            <p className="text-dark opacity-75 mb-2">
              Retail Agents operating outside the United Kingdom must comply
              with applicable laws and regulations in the jurisdictions in which
              they operate.
            </p>
            <p className="text-dark opacity-75 mb-4">
              International participation may be subject to additional
              eligibility requirements, restrictions or programme terms.
            </p>

            <h5 className="title_text text-dark">
              15. Responsibility for Agent Conduct
            </h5>
            <p className="text-dark opacity-75 mb-2">
              Retail Agents are responsible for their own statements,
              communications and promotional activities.
            </p>
            <p className="text-dark opacity-75 mb-2">
              TopCoin UK Ltd may take appropriate action where a Retail Agent
              acts outside the authority granted under the Retail Agent
              Programme or breaches applicable terms or policies.
            </p>
            <p className="text-dark opacity-75 mb-4">
              Nothing in this Agreement excludes or limits liability where doing
              so would be unlawful.
            </p>

            <h5 className="title_text text-dark">
              16. Platform Rules and Changes
            </h5>
            <p className="text-dark opacity-75 mb-2">
              TopCoin UK Ltd may update the Retail Agent Programme, platform
              functionality, eligibility requirements and operational rules
              where reasonably necessary for legal, regulatory, security,
              operational or business reasons.
            </p>
            <p className="text-dark opacity-75 mb-2">
              Material changes will be communicated in accordance with the
              applicable platform terms.
            </p>
            <p className="text-dark opacity-75 mb-4">
              Continued participation may be subject to acceptance of updated
              terms where required.
            </p>

            <h5 className="title_text text-dark">
              17. Suspension and Termination
            </h5>
            <p className="text-dark opacity-75 mb-2">
              TopCoin UK Ltd may restrict, suspend or terminate a Retail Agent's
              participation in accordance with this Agreement and applicable
              platform policies, including where necessary to protect customers,
              businesses, the platform or the TopCoin UK brand.
            </p>
            <p className="text-dark opacity-75 mb-4">
              Retail Agents may also cease participating in the programme in
              accordance with the applicable termination procedure.
            </p>

            <h5 className="title_text text-dark">
              18. TopCoin UK Business Network
            </h5>
            <p className="text-dark opacity-75 mb-2">
              Businesses introduced by Retail Agents become participants within
              the <strong>TopCoin UK platform network</strong> once accepted and
              onboarded.
            </p>
            <p className="text-dark opacity-75 mb-2">
              The introducing Retail Agent does not acquire ownership, control
              or exclusive rights over those businesses.
            </p>
            <p className="text-dark opacity-75 mb-4">
              Participating businesses maintain their own relationship with
              TopCoin UK and participate in accordance with the applicable
              business terms and platform rules.
            </p>

            <h5 className="title_text text-dark">
              19. No Lifetime Rights or Ownership of Businesses
            </h5>
            <p className="text-dark opacity-75 mb-2">
              Participation as a Retail M Agent or Senior Retail Agent does not
              grant an Agent permanent or lifetime ownership, control or
              exclusive rights over businesses they introduce.
            </p>
            <p className="text-dark opacity-75 mb-2">
              Retail Agents act as introducers to the TopCoin UK platform and
              are not responsible for the ongoing activities of an introduced
              business except where specific responsibilities are expressly
              stated in the applicable programme terms.
            </p>
            <p className="text-dark opacity-75 mb-2">
              If a Retail Agent's participation ends, businesses previously
              introduced by that Agent may remain participants within the
              TopCoin UK platform.
            </p>
            <p className="text-dark opacity-75 mb-4">
              Any rights or obligations surviving termination will be determined
              by this Agreement and the applicable TopCoin UK terms.
            </p>

            <h5 className="title_text text-dark">20. Platform Ownership</h5>
            <p className="text-dark opacity-75 mb-2">
              The TopCoin UK platform, technology, systems, architecture,
              branding and operational framework remain under the ownership and
              control of TopCoin UK Ltd or their respective rights holders.
            </p>
            <p className="text-dark opacity-75 mb-4">
              Participation as a Retail M Agent or Senior Retail Agent does not
              grant ownership rights in TopCoin UK Ltd, the platform or its
              business network.
            </p>

            <h5 className="title_text text-dark">21. Governing Law</h5>
            <p className="text-dark opacity-75 mb-2">
              This Agreement is governed by the laws of{" "}
              <strong>England and Wales</strong>.
            </p>
            <p className="text-dark opacity-75 mb-4">
              Any disputes relating to this Agreement will be handled in
              accordance with the dispute-resolution and jurisdiction provisions
              contained in the applicable TopCoin UK terms.
            </p>

            <p className="text-dark opacity-75 mt-4 text-center">
              <strong>TopCoin UK Ltd</strong>
              <br />
              Retail &amp; Loyalty Platform
            </p>

            <hr className="mt-5 mb-5" />

            <h5 className="title_text text-dark">
              Website Summary: Become a TopCoin UK Retail Agent
            </h5>
            <p className="text-dark opacity-75 mb-2">
              Help expand the TopCoin UK business network by introducing shops,
              retailers and other eligible businesses to the platform.
            </p>
            <p className="text-dark opacity-75 mb-4">
              Joining TopCoin UK does not automatically make you a Retail Agent.
              Apply through the platform and, once approved, you can begin
              introducing prospective businesses using your authorised Retail
              Agent facilities.
            </p>
            <p className="text-dark fw-bold mb-4 text-center border border-2 border-dark p-3 ">
              JOIN TOPCOIN UK &gt; APPLY TO BECOME A RETAIL AGENT &gt; GET
              APPROVED &gt; INTRODUCE BUSINESSES &gt; HELP GROW THE NETWORK
            </p>
            <p className="text-dark opacity-75 mb-4">
              <strong>Review note:</strong> As this is intended as a UK
              commercial agreement, the final published terms should be reviewed
              by a qualified UK solicitor.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RetailAgentAgreement;
